import type { AuthenticationAccessRight } from "../../authentication/objects/AuthenticationToken";

export default class SmartLinkAccessRight {
  public static VIEW_SMART_LINKS: AuthenticationAccessRight = ({ menuDisplayLevel }) =>  menuDisplayLevel <= 2 || menuDisplayLevel >= 2 || menuDisplayLevel >= 4;
}
